export default __webpack_public_path__ + "static/media/Maduro1Open.5a84e553.jpg";